<template>
  <div>
    <Header></Header>
    <div class="container">
      <div class="articlelist">
        <div class="loading-wrap"><i class="el-icon-loading" v-show="showLoading"></i></div>
        <el-table :data="articleList" v-show="!showLoading">
          <el-table-column prop="date" label="热门推荐">
            <template slot-scope="scope">
              <div class="title">
                <router-link
                  :to="'/article-'+scope.row.id+'.html'"
                  class="left"
                >
                  <h4>{{ scope.row.title }}</h4>
                </router-link>
              </div>
              <div style="clear: both"></div>
              <div class="desc-container">
                <div class="desc online left">{{ scope.row.desc }}</div>
                <div class="right views">
                  <i class="el-icon-view right">&nbsp;{{ scope.row.views }}</i>
                  <i class="el-icon-chat-line-square right">&nbsp;{{ scope.row.commnum }}</i>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalNum"
        :page-size="15"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
h4 {
  padding: 0px;
  margin: 0px;
  padding-bottom: 6px;
}
.articlelist {
  text-align: left;
  margin: 0 auto;
  margin-bottom: 16px;
  padding:16px;
}
.left {
  float: left;
}
.right {
  float: right;
}
.title {
  position: relative;
}
.close-btn {
  padding-top: 4px;
}
.desc {
  font-size: 14px;
  color: #8a8a8a;
  width: 80%;
}
.online {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.views {
  line-height: 23px;
  padding-top: 6px;
}
.views > i {
  padding-left: 8px;
}
.loading-wrap{width:48px;margin:0 auto;}
</style>
<script>
import "../assets/css/common.css";
import Header from "../components/headernew.vue";
// import { Decimal } from 'decimal.js'

export default {
  components: {
    Header,

  },
  data() {
    return {
      totalNum: 0,
      articleList: [],
      pageIndex: 1,
      showLoading:true //loading当中
    };
  },
  mounted() {
    //测试decimal
    // let a=2.55
    // let b=48
    // console.log(a*b)
    // let c=new Decimal(a).mul(b)
    // console.log(c.toNumber());
    this.showLoading=true;
    this.getTotalNum();
    this.getList(1);
  },
  methods: {
    getTotalNum() {
      this.$http
        .get("/api/articleview/count/0")
        .then((r) => {
          this.totalNum = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getList(pageIndex) {
      this.pageIndex = pageIndex;
      var keyword=this.$route.query.kw;
      if(keyword==undefined || keyword==null)keyword='';
     
      this.$http
        .get("/api/articleview2/list/0/" + pageIndex+"?kw="+keyword)
        .then((r) => {
          console.log(r);
          //获取角色列表
          if (r.data.code == 200) {
            this.articleList = r.data.data;
          } else {
            this.$alert("获取数据失败，请重试", "", {
              confirmButtonText: "确定",
            });
          }
          this.showLoading=false;
        })
        .catch((e) => {
          console.log(e);
          this.showLoading=false;
        });
    },
    handleCurrentChange(pageIndex) {
      this.getList(pageIndex);
    },
  },
};
</script>
